import React from 'react';
import PropTypes from 'prop-types';
import Chapter3Status from 'common/Customers/Chapter3Status';

const TierOwnershipBlock = ({
  intermediaryTitle,
  ownershipValue,
  chapter3Status
}) => {
  const directAllocationAllowed = chapter3Status && Chapter3Status.findByName(chapter3Status).directAllocationAllowed;
  const isInvalidOwnership = !directAllocationAllowed && ownershipValue !== 100;

  return (
    <div className={ `${ isInvalidOwnership ? 'invalid-ownership ' : '' }tier-ownership-container` }>
      <div className="tier-ownership-text-left" data-testid="tier-ownership-owners">
        Intermediary for <b>{intermediaryTitle}</b>
      </div>
      <div className="tier-ownership-text-right" data-testid="tier-ownership-percent">
        Ownership: <b className={ isInvalidOwnership ? 'invalid-ownership-value ' : '' }>{ownershipValue} %</b>
      </div>
    </div>
  );
};

TierOwnershipBlock.propTypes = {
  intermediaryTitle: PropTypes.string.isRequired,
  ownershipValue: PropTypes.number.isRequired,
  chapter3Status: PropTypes.string.isRequired
};

export default TierOwnershipBlock;
